export default "__VITE_ASSET__BMlNhonG__"